<script setup>
import { ref } from 'vue';
import { useClickAway } from '@/utils/useClickAway';
const { isModalOpen, marginTop, justify, align, shouldTeleport } = defineProps({
  justify: {
    type: String,
    default: 'center',
  },
  align: {
    type: String,
    default: 'center',
  },
  isModalOpen: {
    type: Boolean,
    required: true,
    default: false,
  },
  shouldTeleport: {
    type: Boolean,
    default: true,
  },
  marginTop: {
    type: String,
    default: 'mt-36',
  },
});
const emit = defineEmits(['closeModal']);
const modalRef = ref(null);
useClickAway(modalRef, () => emit('closeModal'));
</script>

<template>
  <div :class="{ 'h-full pb-14': !shouldTeleport }">
    <Teleport
      v-if="shouldTeleport"
      to="body"
    >
      <div
        v-if="isModalOpen"
        class="fixed left-0 top-0 z-30 flex h-screen w-full overflow-y-scroll bg-dark-gray bg-opacity-50 pb-16"
        :class="[
          justify === 'end' ? 'justify-end' : 'justify-center',
          align === 'start' ? 'items-start' : 'items-center',
        ]"
      >
        <div
          ref="modalRef"
          :class="marginTop"
        >
          <slot></slot>
        </div>
      </div>
    </Teleport>
    <slot v-else></slot>
  </div>
</template>

<style scoped></style>
